import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-poster-ink text-slate-400 py-12 px-6 border-t border-slate-800">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-start gap-8">
        <div>
          <span className="font-poster text-2xl uppercase text-white">PRINTPULSE DIRECT</span>
          <p className="text-xs text-poster-muted mt-2 max-w-sm">
            Independent technical provider specializing in rapid printer troubleshooting for home and small business
            users.
          </p>
          <div className="flex gap-5 mt-4">
            <Link to="/" data-testid="footer-link-home" className="text-xs font-mono-lbl uppercase tracking-widest text-slate-300 hover:text-white transition-colors">Home</Link>
            <Link to="/services" data-testid="footer-link-services" className="text-xs font-mono-lbl uppercase tracking-widest text-slate-300 hover:text-white transition-colors">Services</Link>
            <Link to="/contact" data-testid="footer-link-contact" className="text-xs font-mono-lbl uppercase tracking-widest text-slate-300 hover:text-white transition-colors">Contact</Link>
          </div>
        </div>

        <div
          data-testid="trademark-disclaimer"
          className="max-w-md text-xs text-poster-muted leading-relaxed border-l-2 border-slate-700 pl-6"
        >
          <p className="font-bold text-white uppercase tracking-wider mb-1 font-mono-lbl text-[11px]">
            Trademark Disclaimer
          </p>
          PrintPulse Direct is an independent service provider and is not affiliated with, endorsed by, sponsored by,
          or connected to Canon Inc. or any official Canon manufacturer programs. All brand names are used strictly for
          compatibility identification.
        </div>
      </div>
      <div className="max-w-6xl mx-auto mt-8 pt-6 border-t border-slate-800 text-[10px] font-mono-lbl text-slate-500 flex flex-col sm:flex-row gap-2 justify-between">
        <span>&copy; PrintPulse Direct. Independent Support.</span>
        <span>Same-Day On-Site &amp; Remote Diagnosis</span>
      </div>
    </footer>
  );
}
